import { render, staticRenderFns } from "./TanpinNebiki.vue?vue&type=template&id=1979fe74&scoped=true&"
import script from "./TanpinNebiki.vue?vue&type=script&lang=js&"
export * from "./TanpinNebiki.vue?vue&type=script&lang=js&"
import style0 from "./TanpinNebiki.vue?vue&type=style&index=0&id=1979fe74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979fe74",
  null
  
)

export default component.exports